import "core-js/modules/es.date.to-string.js";

var _a;

import { SET_TOKEN, LOGOUT } from "./Types";
import { IS_DEV } from "@/common/fhtGlobalEnv";
import { defaultHeaders } from "@/apis/api/api";
var ACCESS_TOKEN_KEY = "access_token";

var _accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);

var access_token;

if (_accessToken && _accessToken.length) {
  try {
    access_token = JSON.parse(_accessToken);

    if (access_token.tokenExpires < new Date()) {
      access_token = undefined; //expired
    }
  } catch (err) {
    console.warn(err);
    localStorage.removeItem(ACCESS_TOKEN_KEY);
  }
}

var initialState = {
  loginUserName: localStorage.getItem("username") || undefined,
  loginPassword: localStorage.getItem("password") || undefined,
  token: access_token
};

if ((_a = initialState === null || initialState === void 0 ? void 0 : initialState.token) === null || _a === void 0 ? void 0 : _a.token) {
  defaultHeaders.Authorization = "bearer " + initialState.token.token;
  IS_DEV && console.log("SET authorization token!!!");
}

export function LoginReducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case SET_TOKEN:
      return {
        token: action.token.token,
        loginUserName: action.token.username,
        loginPassword: action.token.password
      };

    case LOGOUT:
      return {
        loginUserName: undefined,
        loginPassword: undefined,
        token: undefined
      };

    default:
      return state;
  }
}